import React, { useEffect, useState } from 'react';
import { ArrowLeft, CalendarDays, MonitorSmartphone, ShieldCheck } from 'lucide-react';
import { Link, useParams } from 'react-router-dom';
import { getPublicNotice } from '../api';
import './PublicNotices.css';


function PublicNoticeDetail() {
    const { ticketId } = useParams();
    const [notice, setNotice] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        getPublicNotice(ticketId)
            .then(setNotice)
            .catch((error) => setNotFound(error.response?.status === 404))
            .finally(() => setIsLoading(false));
    }, [ticketId]);

    if (isLoading) return <div className="notices-state">Loading public notice...</div>;

    if (!notice) {
        return (
            <div className="notices-state notices-detail-state">
                <ShieldCheck size={28} />
                <strong>{notFound ? 'Public notice not found' : 'Public notice unavailable'}</strong>
                <span>The ticket may be private or no longer published.</span>
                <Link to="/notices">Return to notice board</Link>
            </div>
        );
    }

    return (
        <article className="notice-detail">
            <Link to="/notices" className="notice-back"><ArrowLeft size={16} /> Notice board</Link>
            <header className="notice-detail-header">
                <div className="notice-detail-id"><ShieldCheck size={16} /> SC-{notice.id.slice(0, 8).toUpperCase()}</div>
                <h1>{notice.public_title}</h1>
                <div className="notice-detail-meta">
                    <span><CalendarDays size={16} /> Published {new Date(notice.published_at).toLocaleDateString()}</span>
                    <span><MonitorSmartphone size={16} /> {notice.phone_model}</span>
                </div>
            </header>

            <section className="notice-summary" aria-labelledby="notice-summary-title">
                <span className="notice-section-label" id="notice-summary-title">Public summary</span>
                <p>{notice.public_summary}</p>
            </section>

            <section className="notice-context" aria-label="Affected environment">
                <div><span>Device model</span><strong>{notice.phone_model}</strong></div>
                <div><span>System version</span><strong>{notice.system_version}</strong></div>
                <div><span>App version</span><strong>{notice.software}</strong></div>
                {notice.security_version && <div><span>Security version</span><strong>{notice.security_version}</strong></div>}
            </section>

            <p className="notice-disclosure-note">
                Reporter identity, attachments, reproduction details, and internal communication are withheld from this disclosure.
            </p>
        </article>
    );
}

export default PublicNoticeDetail;
